import { Injector, NgModule } from '@angular/core';
import { UsersRoutingModule } from './users-routing.module';
import { PluginService } from '../../plugins/services/plugin.service';
import { UserRolePlugin } from '../../authentication/plugins/user-role/user-role.plugin';
import { QuickAdditService } from '../../quick-addit/services/quick-addit.service';
import { BootstrapModule } from '../../support/modules/bootstrap-module';
import { BootstrapModuleContract } from '../../support/modules/interfaces/bootstrap-module.interface';
import { MenuService } from '../../menu/services/menu.service';
import { UserService } from '../../authentication/services/user.service';
import { MenuModule } from '../../menu/menu.module';
import { QuickAdditModal } from '../../quick-addit/modals/quick-addit.modal';
import { RoleService } from '../../authentication/services/role.service';
import { EntityService } from '../../entities/services/entity.service';

@NgModule({
    imports: [
        UsersRoutingModule,
        MenuModule,
    ],
    exports: [],
    declarations: [],
    providers: [RoleService],
})
export class UsersModule extends BootstrapModule implements BootstrapModuleContract {

    public boot(injector: Injector) {
        const quickAddit = this.injector.get(QuickAdditService);

        console.log('register quickaddit user');

        const structure = {
            groups: [
                {
                    name: 'tab1',
                    title: 'Tab 1',
                    sections: [
                        {
                            name: '',
                            title: '',
                            show_label: false,
                            rows: [
                                {
                                    row_related: '',
                                    elements: [
                                        {
                                            id: 'type',
                                            type: 'select',
                                            name: 'type',
                                            label: 'Type',
                                            validation: {
                                                required: true
                                            },
                                            config: {
                                                options: [
                                                    {key: '1', value: '1'},
                                                    {key: '2', value: '2'}
                                                ]
                                            },
                                            attributes: {
                                                class: ['col-sm-12'],
                                                placeholder: 'Type',
                                            },
                                        }
                                    ]
                                },
                                {
                                    row_related: '',
                                    elements: [
                                        {
                                            id: 'name',
                                            type: 'text',
                                            name: 'name',
                                            label: 'Name',
                                            validation: {
                                                required: true
                                            },
                                            conditions: [
                                                {
                                                    element: 'type',
                                                    operator: '===',
                                                    condition: '1'
                                                }
                                            ],
                                            config: {},
                                            attributes: {
                                                class: ['col-sm-12'],
                                                placeholder: 'Name',
                                            },
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        };

        quickAddit
            .register('user', UserService)
            .defaults({
                name: 'John Doe'
            })
            .multiStep([
                {
                    structure: structure,
                    success(modal: QuickAdditModal) {

                        const entityName = injector.get(RoleService).entityName;
                        const structure  = injector.get(EntityService).getDefaultForm(entityName);

                        modal.formStructure = structure;

                        return Promise.resolve();

                    }
                }
            ])
            .tabs((tabs: any) => {
                tabs.add('Roles', 'roles', {order: 100});
            })
            .plugins((plugins: any) => {
                plugins.add('roles', 'core-user-roles', UserRolePlugin, 'both', 0);
            });
    }


    public plugins(plugins: PluginService): void {
        plugins.add('chassis-core-user-edit-sidebar', 'core-user-roles', UserRolePlugin, 0);
    }

    public menus(menus: MenuService) {
        const menu = menus.get('sidebar');

        menu.add('users', 'Users', 'users.index', {
            icon: 'fa fa-users', order: 90, permission: 'user.read'
        });
        menu.get('users').add('users', 'Users', 'users.index', {
            icon: 'fa fa-users',
            permission: 'user.read'
        });
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/users/users.module.ts